import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ChatModalMenuItem"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["click"],
  setup(__props, { emit: __emit }) {

let emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})